import Rails from '@rails/ujs';
import $ from 'jquery'; // eslint-disable-line
// import bootstrap.bundle.js instead of bootstrap.js to includes popper.js for enable tooltips
import bootstrap from 'bootstrap/dist/js/bootstrap.bundle.js';
import '@nathanvda/cocoon';

import './common/append_form_action_on_click';
import './common/change_circle_button';
import './common/clear_on_click';
import './common/count_chars';
import './common/copy_form_value';
import './common/count_tag_on_modal_close';
import './common/data_link';
import './common/disable_on_checked';
import './common/disable_on_empty';
import './common/disable_on_submit';
import './common/disable_on_submit_v2';
import './common/dont_see_more';
import './common/edit_message';
import './common/hide_deleted_cocoon_items';
import './common/hide_on_unchecked';
import './common/modal_default_open';
import './common/move_higher';
import './common/move_lower';
import './common/nested_checkbox';
import './common/prevent_enter_submission';
import './common/scroll_to_bottom';
import './common/see_more';
import './common/select_template';
import './common/set_value_on_load';
import './common/show_file_list';
import './common/submit_on_change';
import './common/support_request_done';
import './common/toggle_enable_on_checked';
import './common/update_badges';
import './common/watch_changes';
import './pages/job_csv';
import './pages/job_entry_contract';
import './pages/set_end_at_on_change';
import './pages/saas_content_edit';
import './pages/saas_editing_comment_edit';
import './lazy_loader/load_trix';

$(() => {
  $('[data-bs-toggle="tooltip"]').each(function () {
    new bootstrap.Tooltip(this);
  });
});

Rails.start();
